import { Box, Typography } from "@mui/material";
import OTPInputs from "components/general/auth/OTPInputs";
import { OTP_TYPE } from "constants/general";
import MESSAGES from "constants/messages";
import {
  Fragment,
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import OTPInput from "react-otp-input";
import { resendOtp, setVerifyingOtp, verifyOtp } from "slices/authReducers";
import { handleSnackBar } from "slices/global";
import { useAppDispatch, useAppSelector } from "store/appHooks";
import { toMMSS } from "utils/timestamp.util";

const VerifyMobileOtp = forwardRef(
  (
    {
      onSuccess,
      email,
      otpType,
      phone,
      otp,
      setOtp,
    }: {
      onSuccess: any;
      email?: string;
      otpType: number;
      phone?: string;
      otp?: any;
      setOtp?: any;
    },
    ref
  ) => {
    const dispatch = useAppDispatch();
    const { authReducer }: any = useAppSelector((state) => state);
    const { otpTokenData, verifyingOtp }: any = authReducer;
    // TODO remove once email gets triggerd from API

    const RESEND_TIME_SEC = 10;
    const [allowResend, setAllowResend] = useState(false);
    const [timeSec, setTimeSec] = useState(RESEND_TIME_SEC);
    const [otpError, setOtpError] = useState("");

    useEffect(() => {
      return () => {
        dispatch(setVerifyingOtp(false));
        setOtp("");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeOtp = (v: string) => setOtp(v);

    const verifyOtpCall = (inpOtp: any) => {
      console.log({ inpOtp });
      if (otpTokenData?.token) {
        dispatch(
          verifyOtp({
            data: { token: otpTokenData?.token, otp: inpOtp },
            navigate: () => {
              onSuccess();
            },
          })
        );
      } else {
        dispatch(
          handleSnackBar({
            open: true,
            message: MESSAGES.APP_ERROR,
            severity: "error",
          })
        );
      }
    };

    const resend = () => {
      setTimeSec(0);
      dispatch(
        resendOtp({
          data: {
            ...(otpType === OTP_TYPE.EMAIL
              ? { email }
              : { mobile_number: phone }),
            otp_type: OTP_TYPE.EMAIL,
          },
          navigate: () => {
            setTimeSec(RESEND_TIME_SEC);
            setAllowResend(false);
          },
        })
      );
    };

    useImperativeHandle(ref, () => ({
      verifyOtp: verifyOtpCall,
    }));
    console.log({ timeSec, boo: timeSec > 0 });
    return authReducer.otpVerification ? (
      <Fragment>
        <Box>
          {/* <Box> */}
          <Box display="flex" justifyContent="center">
          <style>
              {`
          input::-webkit-outer-spin-button,
          input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }
          input[type=number] {
            -moz-appearance: textfield;
          }
        `}
            </style>
            <OTPInput
              value={otp}
              onChange={onChangeOtp}
              numInputs={6}
              inputType="number"
              inputStyle={{
                appearance: "none",

                margin: 0,
              }}
              renderSeparator={<span>&nbsp;&nbsp;&nbsp;</span>}
              renderInput={(props: any, index: number): any => (
                <input
                  {...props}
                  className="otp-input"
                  style={{
                    width: "30%",
                    height: 50,
                    textAlign: "center",
                    border: "none",
                    borderBottom: "1px solid black",
                    outline: 0,
                    appearance: "none",

                    margin: 0,
                  }}
                  // onChange={(e: any) => {
                  //   return [1, 2, 3, 4, 5, 6, 7, 8, 9, 0].includes(
                  //     Number(e.target.value)
                  //   )
                  //     ? props.onChange(e)
                  //     : null;
                  // }}
                  onChange={props?.onChange}
                  autoFocus={index === 0}
                  onKeyPress={(e: any) => {
                    setOtpError("");
                    if (e.key === "Enter") {
                      if (otp.length === 6) {
                        verifyOtpCall(otp);
                      } else {
                        setOtpError("Please enter 6 digit OTP");
                      }
                    }
                  }}
                />
              )}
            />

            {/* <OTPInputs
              onChange={onChangeOtp}
              validateForm={(e: any) => {
                setOtpError("");
                if (e.key === "Enter") {
                  if (otp.length === 6) {
                    verifyOtpCall();
                  } else {
                    setOtpError("Please enter 6 digit OTP");
                  }
                }
              }}
            /> */}
            {otpError && (
              <Typography color="error" fontSize={12} mt={1}>
                {otpError}
              </Typography>
            )}
          </Box>

          {timeSec > 0 && (
            <Box mt={1.5}>
              <Typography
                fontSize="15px"
                fontWeight={400}
                lineHeight="20px"
                color="#323232"
                display="flex"
                alignItems="center"
                justifyContent="flex-start"
              >
                You will get OTP in:
                <Counter
                  onTimerComplete={() => {
                    setAllowResend(true);
                    setTimeSec(0);
                  }}
                  timeSec={timeSec}
                />{" "}
              </Typography>
            </Box>
          )}

          <Box mt={3}>
            <Typography
              color="#A2A2A2"
              fontSize="15px"
              fontWeight={400}
              textAlign="center"
              lineHeight="18.15px"
            >
              Didn’t get OTP?{" "}
              <Typography
                fontSize="15px"
                component="span"
                color="#D21A00"
                fontWeight={400}
                style={{ cursor: "pointer", opacity: allowResend ? 1 : 0.5 }}
                onClick={() => allowResend && resend()}
              >
                Resend
              </Typography>
            </Typography>
          </Box>
          {/* <Box mt={2}>
          <Button
            fullWidth
            variant="contained"
            disabled={otp.length !== 6 || verifyingOtp}
            size="large"
            endIcon={verifyingOtp ? <CircularProgress size={20} /> : null}
            onClick={verifyOtpCall}
          >
            {!verifyingOtp && `Verify Account`}
          </Button>
        </Box> */}
        </Box>
      </Fragment>
    ) : null;
  }
);

const Counter = ({
  onTimerComplete,
  timeSec,
}: {
  onTimerComplete: any;
  timeSec: number;
}) => {
  const [count, setCount] = useState(timeSec);
  console.log({ count });
  useEffect(() => {
    //Implementing the setInterval method
    const interval = setInterval(() => {
      setCount(count - 1);
      if (count - 1 === 0) {
        onTimerComplete();
      }
    }, 1000);

    //Clearing the interval
    return () => clearInterval(interval);
  }, [count, onTimerComplete]);

  return <Typography>{toMMSS(count)}</Typography>;
};

export default VerifyMobileOtp;
